import { UserInfo } from '~/src/store/modules/user/types';
import { OFetchRequestOptions, useOFetch } from '../../requests';
import { CustomFetchContext } from '../../requests/types';
import { ApiResponse, ApiResponsePromise } from '../../types';

// 获取用户信息
export const fetchUserInfo = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): ApiResponsePromise<UserInfo> => {
  return await useOFetch<UserInfo>(
    '/center/user/index/ajax-get-user-info',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};
